import { lazy } from 'react';

const BotelImageSection = lazy(() => import('../BotelImageSection'));

const BotelImageSectionLazy = () => {
  return <BotelImageSection />;
};

export default BotelImageSectionLazy; 